import React, { useState, useEffect, useContext } from 'react';
import { loader } from 'graphql.macro';
import { useMutation } from 'react-apollo-hooks';
import { Redirect, withRouter } from 'react-router-dom';

import { ProfileContext } from '@loyalup/core';

import { Loader } from '@loyalup/ui';

import useQueryParams from 'utils/hooks/useQueryParams';

import s from './Integrations.module.css';

const ME_QUERY = loader('../../../gql/queries/Me.gql');
const SETUP_POSTER_INTEGRATION_MUTATION = loader('../../../gql/mutations/SetupPosterIntegration.gql');

const CheckPoster = ({ history }) => {
  const [loading, setLoading] = useState(true);
  const queryParams = useQueryParams();
  const { company } = useContext(ProfileContext);
  const [setupPosterIntegration] = useMutation(SETUP_POSTER_INTEGRATION_MUTATION);

  useEffect(() => {
    (async () => {
      if (company.integrationMode !== 'NOTHING') {
        history.push('/settings/integrations');
      } else {
        try {
          await setupPosterIntegration({
            variables: {
              code: queryParams.get('code'),
              account: queryParams.get('account'),
            },
            refetchQueries: [{ query: ME_QUERY }],
          });
        } catch (e) {
          console.log(e);
        }

        setLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return (
      <div className={s.centered}>
        <Loader />
      </div>
    );
  }

  return <Redirect to="/settings/integrations" />;
};

export default withRouter(CheckPoster);
